module.exports = __webpack_public_path__ + "img/Reveal_Popup_Icon.bf488d29.svg";